import styled from 'styled-components';

export const Container = styled.div`
  .generated-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 0 20px;
    color: #21354a;
  }

  .generated-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    padding: 3px 8px;
    font-size: 12px;
    font-weight: 600;
    background: #d4edda;
    color: #155724;

    .material-icons-outlined {
      font-size: 16px;
    }
  }

  .generated-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #dee2e6;
  }

  .stat-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    padding: 16px;

    small {
      display: block;
      font-size: 13px;
      color: #6c757d;
    }

    strong {
      display: block;
      margin-top: 6px;
      font-size: 15px;
      font-weight: 600;
      color: #21354a;
    }
  }

  .files-toolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;

    h2 {
      font-size: 18px;
      font-weight: 500;
      color: #21354a;
      margin-bottom: 4px;
    }

    small {
      font-size: 13px;
      color: #6c757d;
    }

    .btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;

      .material-icons-outlined {
        font-size: 18px;
      }
    }
  }

  .files-bulk {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;

    label {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #21354a;
    }
  }

  .files-group {
    margin-bottom: 20px;

    h3 {
      font-size: 16px;
      font-weight: 500;
      color: #21354a;
      margin-bottom: 10px;
    }
  }

  .files-table {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
  }

  .files-row {
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 56px;
    padding: 10px 16px;
    border-top: 1px solid #dee2e6;
    color: #21354a;

    &:first-child {
      border-top: 0;
    }

    &.selected {
      background: #edf5ff;
    }
  }

  .files-head {
    min-height: 46px;
    background: #f8f9fa;
    font-size: 14px;
    font-weight: 600;
  }

  .files-check {
    width: 24px;
    flex-shrink: 0;
    display: flex;
  }

  .files-name {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .files-kind {
    width: 220px;
    flex-shrink: 0;
  }

  .files-actions {
    width: 120px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }

  .icon-only {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .material-icons-outlined {
      font-size: 18px;
    }
  }

  .files-preview {
    background: #e9ecef;
    border-top: 1px solid #dee2e6;
    padding: 24px;
    display: flex;
    justify-content: center;

    iframe {
      width: 100%;
      max-width: 800px;
      height: 640px;
      border: 0;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }

    img {
      max-width: 100%;
      max-height: 640px;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }
  }

  .files-selo {
    border-radius: 4px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .selo-pendente {
    background: #fff3cd;
    color: #856404;
  }

  .selo-confirmado {
    background: #d4edda;
    color: #155724;
  }
`;
